"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorTypes = void 0;
var ColorTypes;
(function (ColorTypes) {
    ColorTypes["HEX"] = "hex";
    ColorTypes["RGB"] = "rgb";
    ColorTypes["HSL"] = "hsl";
    ColorTypes["KEYWORD"] = "keyword";
    ColorTypes["FILTER"] = "filter";
})(ColorTypes = exports.ColorTypes || (exports.ColorTypes = {}));
